import { ZfIcon } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import type { ITool } from '../../../interfaces/tool';

interface IProps {
    tool: ITool;
    hasBorderBottom?: boolean;
}

export const ToolLink: FunctionComponent<IProps> = ({ tool, hasBorderBottom }) => {
    const { i18n } = useTranslation();

    return (
        <a
            key={tool.id}
            className="zf-tool-link"
            target="_blank"
            rel="noreferrer"
            href={tool.link}
            style={{ borderBottom: hasBorderBottom ? '1px solid var(--border-color-default-normal)' : '' }}
        >
            <ZfIcon name="open_in_new" size="small" />
            {tool.name[i18n.language]}
        </a>
    );
};
